// /app/frontend/src/api/rooms.js
import api from "./client";

export async function listRooms() {
  const res = await api.get("/rooms");
  return res.data;
}

export async function getRoom(slug) {
  const res = await api.get(`/rooms/${slug}`);
  return res.data;
}

export async function getRoomPin(slug) {
  const res = await api.get(`/rooms/${slug}/pin`);
  return res.data;
}

export async function listRoomPosts(slug, { limit = 30, before = null } = {}) {
  const params = { limit };
  if (before) params.before = before;
  const res = await api.get(`/rooms/${slug}/posts`, { params });
  return res.data;
}

export async function createRoomPost(slug, content, channel = null) {
  const payload = { content };
  if (channel) {
    payload.channel = channel;
  }
  const res = await api.post(`/rooms/${slug}/posts`, payload);
  return res.data;
}

export async function listPostReplies(postId) {
  const res = await api.get(`/rooms/posts/${postId}/replies`);
  return res.data;
}

export async function createReply(postId, content) {
  const res = await api.post(`/rooms/posts/${postId}/replies`, { content });
  return res.data;
}

export async function reportPost(postId, reason, details = null) {
  const res = await api.post(`/rooms/posts/${postId}/report`, { reason, details });
  return res.data;
}

export async function reportReply(replyId, reason, details = null) {
  const res = await api.post(`/rooms/replies/${replyId}/report`, { reason, details });
  return res.data;
}
